/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = require('./lib/constants')




//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/~/redux-persist/constants.js
// module id = 1203
// module chunks = 60